import {openScheme} from '@xc/hiya-jsbridge'
import {PaymentPage} from 'hiya-common/src/constant'
import {HostMaps} from 'hiya-common/src/utils/host/AutoHost'
import {hAreaCodeEnum} from 'hiya-common/src/reducers/env'
import {createRoom} from 'hiya-common/src/utils'
import * as ShareExternalEntryImages from './images/share-external-entry'
import * as ShareInImages from './images/share-in'

export const GoRecharge = () => {
  openScheme(
    `hiya://openWindow?fullscreen=1&external=0&need_user_info=1&url=${PaymentPage}`
  )
}

export const getActivityLink = ({id, otherInfo = {}, fullscreen = 1}) => {
  if (!id) return ''

  const other_info = encodeURIComponent(
    JSON.stringify({
      ...otherInfo,
    })
  )

  return `hiya://openWindow?need_user_info=1&fullscreen=${fullscreen}&disable_native_gesture=1&external=0&other_info=${other_info}&url=${HostMaps.auto.activity}/ToyBricksView/${id}`
}

export const externalImg = {
  [hAreaCodeEnum.ar]: `${HostMaps.prod.img01}/img/png/id/551538513988`,
  [hAreaCodeEnum.id]: `${HostMaps.prod.img01}/img/png/id/551538512792`,
  [hAreaCodeEnum.vi]: `${HostMaps.prod.img01}/img/png/id/551538513449`,
  [hAreaCodeEnum.tp]: `${HostMaps.prod.img01}/img/png/id/551538512986`,
  [hAreaCodeEnum.th]: `${HostMaps.prod.img01}/img/png/id/551538512243`,
  [hAreaCodeEnum.hi]: `${HostMaps.prod.img01}/img/png/id/551538512986`,
  [hAreaCodeEnum.pk]: `${HostMaps.prod.img01}/img/png/id/551538512986`,
  [hAreaCodeEnum.tr]: `${HostMaps.prod.img01}/img/png/id/551538513676`,
  [hAreaCodeEnum.hk]: `${HostMaps.prod.img01}/img/png/id/551538512986`,
  [hAreaCodeEnum.ms]: `${HostMaps.prod.img01}/img/png/id/551538514162`,
  [hAreaCodeEnum.br]: `${HostMaps.prod.img01}/img/png/id/551538512376`,
}

export const inImg = {
  [hAreaCodeEnum.ar]: `${HostMaps.prod.img01}/img/png/id/551538511540`,
  [hAreaCodeEnum.id]: `${HostMaps.prod.img01}/img/png/id/551538508847`,
  [hAreaCodeEnum.vi]: `${HostMaps.prod.img01}/img/png/id/551538510953`,
  [hAreaCodeEnum.tp]: `${HostMaps.prod.img01}/img/png/id/551538509992`,
  [hAreaCodeEnum.th]: `${HostMaps.prod.img01}/img/png/id/551538506232`,
  [hAreaCodeEnum.hi]: `${HostMaps.prod.img01}/img/png/id/551538509992`,
  [hAreaCodeEnum.pk]: `${HostMaps.prod.img01}/img/png/id/551538509992`,
  [hAreaCodeEnum.tr]: `${HostMaps.prod.img01}/img/png/id/551538511288`,
  [hAreaCodeEnum.hk]: `${HostMaps.prod.img01}/img/png/id/551538509992`,
  [hAreaCodeEnum.ms]: `${HostMaps.prod.img01}/img/png/id/551538511726`,
  [hAreaCodeEnum.br]: `${HostMaps.prod.img01}/img/png/id/551538508473`,
}

/** 世界杯参赛队伍 ID（与后端 team_id 一致，1-48） */
export enum WorldCupTeamEnum {
  墨西哥 = 1,
  南非 = 2,
  韩国 = 3,
  捷克 = 4,
  加拿大 = 5,
  波斯尼亚和黑塞哥维那联邦 = 6,
  卡塔尔 = 7,
  瑞士 = 8,
  巴西 = 9,
  摩洛哥 = 10,
  海地 = 11,
  苏格兰 = 12,
  美国 = 13,
  巴拉圭 = 14,
  澳大利亚 = 15,
  土耳其 = 16,
  德国 = 17,
  库拉索 = 18,
  科特迪瓦 = 19,
  厄瓜多尔 = 20,
  荷兰 = 21,
  日本 = 22,
  瑞典 = 23,
  突尼斯 = 24,
  比利时 = 25,
  埃及 = 26,
  伊朗 = 27,
  新西兰 = 28,
  西班牙 = 29,
  佛得角 = 30,
  沙特 = 31,
  乌拉圭 = 32,
  法国 = 33,
  塞内加尔 = 34,
  伊拉克 = 35,
  挪威 = 36,
  阿根廷 = 37,
  阿尔及利亚 = 38,
  奥地利 = 39,
  约旦 = 40,
  葡萄牙 = 41,
  民主刚果 = 42,
  乌兹别克斯坦 = 43,
  哥伦比亚 = 44,
  英格兰 = 45,
  克罗地亚 = 46,
  加纳 = 47,
  巴拿马 = 48,
}

/** 队伍 i18n key（与 en.json 中 MEX/RSA/... 一致，顺序同 WorldCupTeamEnum） */
export const WORLD_CUP_TEAM_I18N_KEYS = [
  'MEX',
  'RSA',
  'KOR',
  'CZE',
  'CAN',
  'BIH',
  'QAT',
  'SUI',
  'BRA',
  'MAR',
  'HAI',
  'SCO',
  'USA',
  'PAR',
  'AUS',
  'TUR',
  'Ger',
  'CUW',
  'CIV',
  'ECU',
  'NED',
  'JPN',
  'SWE',
  'TUN',
  'BEL',
  'EGY',
  'IRN',
  'NZL',
  'ESP',
  'CPV',
  'KSA',
  'URU',
  'FRA',
  'SEN',
  'IRQ',
  'NOR',
  'ARG',
  'ALG',
  'AUT',
  'JOR',
  'POR',
  'COD',
  'UZB',
  'COL',
  'ENG',
  'GRO',
  'GHA',
  'PAN',
] as const

export type WorldCupTeamI18nKey = (typeof WORLD_CUP_TEAM_I18N_KEYS)[number]

/** 按 team_id（1-48）取 en.json 中 MEX/RSA/... 等 i18n key */
export function getTeamI18nKeyById(teamId: number): WorldCupTeamI18nKey {
  return WORLD_CUP_TEAM_I18N_KEYS[teamId - 1] ?? 'MEX'
}

/** 国家队旗 key（与 img-team-flag/{key}.png 一致，顺序同 WorldCupTeamEnum） */
export const WORLD_CUP_TEAM_FLAG_KEYS = [
  'mexico',
  'south-africa',
  'korea',
  'czech',
  'canada',
  'bosnia',
  'qatar',
  'switzerland',
  'brazil',
  'morocco',
  'haiti',
  'scotland',
  'usa',
  'paraguay',
  'australia',
  'turkey',
  'germany',
  'curacao',
  'ivory-coast',
  'ecuador',
  'netherlands',
  'japan',
  'sweden',
  'tunisia',
  'belgium',
  'egypt',
  'iran',
  'new-zealand',
  'spain',
  'cape-verde',
  'saudi',
  'uruguay',
  'france',
  'senegal',
  'iraq',
  'norway',
  'argentina',
  'algeria',
  'austria',
  'jordan',
  'portugal',
  'dr-congo',
  'uzbekistan',
  'colombia',
  'england',
  'croatia',
  'ghana',
  'panama',
] as const

export const GiftId = {
  [hAreaCodeEnum.tr]: '13000',
  [hAreaCodeEnum.pk]: '13000',
  [hAreaCodeEnum.vi]: '13000',
  [hAreaCodeEnum.hi]: '13000',
  [hAreaCodeEnum.ar]: '13000',
  [hAreaCodeEnum.id]: '13007',
  [hAreaCodeEnum.tp]: '13007',
  [hAreaCodeEnum.th]: '13007',
  [hAreaCodeEnum.ms]: '13007',
  [hAreaCodeEnum.br]: '13007',
  [hAreaCodeEnum.hk]: '13007',
}

export const handleJumpRoom = (room_id, h_area_code) => {
  const giftId = GiftId?.[h_area_code] || GiftId?.[hAreaCodeEnum.tr]
  if (room_id) {
    openScheme(`hiya://openRoom?room_id=${room_id}&gift_id=${giftId}`)
  } else {
    createRoom()
  }
}
